/**
 * 目的: 该js主要解决search-pager的返回按钮逻辑 自动补全返回逻辑场景（从哪来返回到哪里去）(模块间跳转和模块内跳转)
 * 内存对象: menuRoutePathMap: 模块跳转的路由信息对象 ,moduleUseOpen: 用户手动打开的模块信息对象
 * 利用router.afterEach的钩子来维护内存数据，所有的操作都是围绕着__ERP_menuRoutePathMap路由信息来做处理
 * 技术文档：《铸剑返回逻辑设计文档 》https://doc.ky-tech.com.cn/docs/6df38cc7d57141419c9d9c60a4159a3f
 * 说明文档：《铸剑返回逻辑说明文档 》https://doc.ky-tech.com.cn/docs/9f82afa839f244f8a61dd80d76b5bbe3
 */

import store from 'public/store'
import bus from 'public/utils/bus'
import router from '@/layout/router/index'
import { clone } from 'lodash'
import { closeVisitedModule, closeRouteDialog } from 'public/utils/common'


// 以模块为维度记录了路由跳转信息对象
const menuRoutePathMap = {}
// 记录那些模块是被用户主动打开对象
const moduleUseOpen = {}


// 判断非远程包（主包）才在window上挂载, 避免分包复制代码后覆盖
if (!process.env.IS_REMOTE_MODULE) {
  window.__ERP_menuRoutePathMap = menuRoutePathMap
  window.__ERP_moduleUseOpen = moduleUseOpen
}

// 监听被用户手动打开的模块和手动关闭的模块事件
bus.$on('GLOBAL_USE_OPEN_MODULE', setUserOpenModule)
bus.$on('GLOBAL_MENU_CLOSE', deleteUserOpenModule)

// 记录被用户主动打开的模块
function setUserOpenModule(tag) {
  if (!tag) return
  if (tag !== '/') {
    window.__ERP_is_system_open_module = true
    moduleUseOpen[tag] = true
    // 主动打开的模块需要走自己原有逻辑 （清除保存的路由跳转数据） 例如：A->B(详情页) 用户长时间使用后手动打开B模块 返回不要回A，而是回B的列表页
    if (menuRoutePathMap[tag]) {
      menuRoutePathMap[tag] = []
    }
  }
}

// 记录路由跳转的信息
function setModuleComeBackMap(from, to) {
  let toTag = to.meta.tag
  // 相同路由跳转需更新最新的路由 (上下翻页场景)
  if (to.name === from.name) {
    updateRoutePath(from, to)
    return
  }
  // 兼容没有模块tag的路由(模块访问数据)
  if (!toTag) {
    toTag = 'noTagModule'
  }
  if (!menuRoutePathMap[toTag]) {
    menuRoutePathMap[toTag] = []
  }
  const menuRoutePathData = {
    form: {
      name: from.name,
      fullPath: from.fullPath,
      meta: { ...from.meta }
    },
    to: {
      name: to.name,
      fullPath: to.fullPath,
      meta: { ...to.meta }
    }
  }
  // 堆栈push前需要做排除场景
  /**
 * tag: [a->b, b->c]
 * 在push前需要判断如果现在的路由跳转是c->b,就不能push
 * 在push前判断如果现在路由跳转是b->c, 就要替换最后一条路由记录(保证为最新的b的fullPath)
 */
  if (menuRoutePathMap[toTag].length) {
    const newMenuRouteIndex = menuRoutePathMap[toTag].length - 1
    let menuRouteOldMap = menuRoutePathMap[toTag][newMenuRouteIndex]
    if (menuRouteOldMap) {
      const menuRouteOldMapPathKey = menuRouteOldMap.form.name + menuRouteOldMap.to.name
      const menuRouteNewMapPathKey = menuRoutePathData.to.name + menuRoutePathData.form.name
      if (menuRouteOldMapPathKey === menuRouteNewMapPathKey) {
        console.info('%c框架自动返回提示说明:特殊场景(A->B,B->A)不记录路由信息:', 'color: #8b60f0')
        return
      }
      const menuRouteOldMapNameKey = menuRouteOldMap.form.name + menuRouteOldMap.to.name
      const menuRouteNewMapNameKey = menuRoutePathData.form.name + menuRoutePathData.to.name
      if (menuRouteOldMapNameKey === menuRouteNewMapNameKey) {
        menuRoutePathMap[toTag][newMenuRouteIndex].to = menuRoutePathData.to
        console.info('%c框架自动返回提示说明:特殊场景(A->B)(切标签)(A->B)要替换为最新的路由信息(且需要关闭弹窗):A模块详情页跳转到B模块详情页【id为1】,切换到A模块详情页再次跳转到B模块详情页【id为2】,记录的路由跳转信息需要更新，且跳转到B模块详情页需要关闭之前打开的弹窗避免弹窗内容没保存 ', 'color: #8b60f0')
        // 还需要关闭页面的弹窗
        setTimeout(() => {
          closeRouteDialog()
        }, 1)
        return
      }
    }
  }
  menuRoutePathMap[toTag].push(menuRoutePathData)
}

// 相同的路由跳转需要更新为最新的路由信息
// 例如：上下翻页场景 列表页进入详情页 A->B 详情页翻页 B->B1 需将 A->B 更新为 A->B1
function updateRoutePath(from, to) {
  let toTag = to.meta.tag
  if (menuRoutePathMap[toTag] && menuRoutePathMap[toTag].length) {
    const newMenuRouteIndex = menuRoutePathMap[toTag].length - 1
    let menuRouteOldMap = menuRoutePathMap[toTag][newMenuRouteIndex]
    if (menuRouteOldMap) {
      if (menuRouteOldMap.to.fullPath === from.fullPath) {
        menuRoutePathMap[toTag][newMenuRouteIndex].to = to
        console.info('%c框架自动返回提示说明:上下翻页场景需更新路由:A模块列表页进入A详情页，A详情页跳转到B模块详情页，切换回A模块详情页翻页后ID变化后再次跳转到B模块详情页，从B模块详情页返回应该回到最后一次A模块详情页的单Id为最新的那个 ', 'color: #8b60f0')
      }
    }
  }
}

// 判断[a->b, b->c] a为列表tag页 b为编辑新增页 c返回需直接返回a 且删除a->b 和 b-> c的路由信息
function handleSpecialRoute(result, tag) {
  const moduleRouteData = menuRoutePathMap[tag]
  const metaRouteData = result.data
  const metaIndex = result.index
  const previousRouteData = moduleRouteData[metaIndex - 1]
  if (previousRouteData) {
    if (metaRouteData.form.fullPath === previousRouteData.to.fullPath) {
      const metaRouteDataForm = metaRouteData.form
      const metaRouteDataFormMeta = metaRouteDataForm.meta
      //  判断是不是编辑页或者新增页
      const isEditPage = (metaRouteDataFormMeta.pageType !== 'detail' || metaRouteDataFormMeta.pageType === 'edit')
      //  判断当前数据不是首页
      const isNotTag = (metaRouteDataForm.path !== metaRouteDataFormMeta.tag)
      //  判断上一条路由数据是首页
      const isPageTag = (previousRouteData.form.fullPath === previousRouteData.form.meta.tag) && (previousRouteData.form.meta.tag === previousRouteData.to.meta.tag)
      if (isEditPage && isNotTag && isPageTag) {
        result.data.form = previousRouteData.form
        result.index = result.index - 1
        console.info('%c框架自动返回提示说明:自动返回路径被修改【a->b,b->c】被特殊处理为【a->c】:【A模块的列表页跳转到A模块的编辑页，编辑页保存跳转到详情页。详情页返回应回到A模块列表页而不是编辑页】', 'color: #8b60f0', result.data)
      }
    }
  }
}

// 将[a->b, b->c]的路由跳转替换为[a->c] 且需判断a!==c
function erpReplaceComeBackMap(from, to) {
  let toTag = to.meta.tag
  to.meta.erpReplace = null
  if (menuRoutePathMap[toTag] && menuRoutePathMap[toTag].length) {
    const newMenuRouteIndex = menuRoutePathMap[toTag].length - 1
    const menuRouteOldMap = menuRoutePathMap[toTag][newMenuRouteIndex]
    const isNotSamePath = (menuRouteOldMap.form.name === to.name)
    if (menuRouteOldMap && !isNotSamePath) {
      menuRouteOldMap.to = to
      console.info('%c框架自动返回提示说明:针对erpReplace跳转的路由将【a->b】,(b->c)替换为【a->c】:【针对使用erpReplace的跳转不记录跳转信息】', 'color: #8b60f0', menuRoutePathMap)
    }
  }
}

// 获取路由跳转信息
function getModuleRoutePath(tag, name, needDelete = false) {
  const menuRoutePathData = menuRoutePathMap[tag]
  if (menuRoutePathData) {
    // 使用 reduceRight 查找最新的对象和索引位置
    const result = menuRoutePathData.reduceRight((acc, obj, index) => {
      if (obj.to.name === name && acc.index === -1) {
        return { data: clone(obj), index }
      }
      return acc
    }, { data: null, index: -1 })
    // 特殊场景 判断[a->b , b->c]列表跳修改，修改跳详情且没有erpReplace的标识则直接返回[a->c]
    if (result.data && result.data.to && !result.data.to.meta.erpReplace) {
      handleSpecialRoute(result, tag)
    }

    // 是否需要删除路由信息
    if (needDelete) {
      removeModuleRoutePath(result, tag)
    }
    return result.data || null
  }
  return null
}

// 删除模块路由信息
function removeModuleRoutePath (data, tag) {
  if (data.index !== -1) {
    if (menuRoutePathMap[tag]) {
      menuRoutePathMap[tag].splice(data.index)
    }
  }
}

// 设置路由信息的layout
function setRouteLayout (_route) {
  let view = store.state.tagsView.visitedViews.find(v => v.tag === _route.meta.tag)
  if (view) {
    _route.meta.layout = true
  }
}

// 获取路由path通过tag
function getPathByTag (fullPath, tag) {
  let view = store.state.tagsView.visitedViews.find(v => v.tag === tag)
  if (!view) {
    return fullPath
  }
  let path = view.path !== tag ? view.path : tag
  return path
}

// 用户主动关闭模块时清除手动打开的模块信息和对应模块的路由记录（还需要清除相关联模块的数据信息）
function deleteUserOpenModule (menuIds) {
  try {
    const tags = Object.values(store.state.menus)
    menuIds.forEach(id => {
      console.log('id---', id)
      const moduleMenu = tags.find(menu => menu.id === id)
      if (moduleMenu && moduleMenu.menuCode) {
        if (moduleUseOpen[moduleMenu.menuCode]) {
          delete moduleUseOpen[moduleMenu.menuCode]
        }
        delete menuRoutePathMap[moduleMenu.menuCode]
        // 2024-5-15新增场景判断
        deleteOtherModuleRoutePath(moduleMenu.menuCode)
      }
    })
  } catch (error) {
    console.error('ERP_ERROR: deleteUserOpenModule', error)
  }
}

/**
*  2024-5-15新增
*  关闭模块时需要处理相关联的模块的记录也要删除
*  真实场景：打开下单管理 => 进入下单管理详情页 => 跳转电子运单详情页 => 关闭下单管理模块 => 电子运单详情页点击返回
*  线上逻辑：电子运单点击返回会重新打开下单管理详情页
*  修改后逻辑： 电子运单详情页点击返回会走默认的配置回到电子运单列表页
*  基于上述场景，修改在关闭模块的GLOBAL_MENU_CLOSE全局事件中判断其他模块堆栈信息中最后一条的form的模块tag和被关闭模块的tag是不是想等，如相等则删除该记录
*  注意事项：目前的关闭包含用户主动关闭模块和点击返回走自动返回逻辑调用的关闭模块方法closeVisitedModule
*/
function deleteOtherModuleRoutePath(code) {
  try {
    const moduleKeys = Object.keys(menuRoutePathMap)
    moduleKeys.map(item => {
      const moduleMap = menuRoutePathMap[item]
      const moduleMapLastIndex = moduleMap.length - 1
      const moduleMapLastItem = moduleMap[moduleMapLastIndex]
      if (moduleMapLastItem && moduleMapLastItem.form.meta.tag === code) {
        moduleMap.pop()
        console.info('%cc框架自动返回提示说明:模块关闭时删除关联的路由信息：打开下单管理 => 进入下单管理详情页 => 跳转电子运单详情页 => 关闭下单管理模块 => 电子运单详情页点击返回走默认的配置回到电子运单列表页', 'color: #8b60f0', menuRoutePathMap)
      }
    })
  } catch (error) {
  }
}

// 路由跳转之后的钩子判断是否存模块的路由跳转信息
function handComeBackByAfterRouter () {
  router.afterEach((to, from) => {
    // 用户手动打开不记录路由信息
    if (window.__ERP_is_system_open_module) {
      window.__ERP_is_system_open_module = null
      return
    }
    // 返回按钮操作不记录路由信息
    if (from.meta.comeBackStatus) {
      from.meta.comeBackStatus = null
      // 返回后需移除对应的路由跳转信息
      getModuleRoutePath(from.meta.tag, from.name, true)
      return
    }
    // 模块切换等场景不需要记录路由跳转信息
    if (to.meta.layout) {
      return
    }
    // 判断erpReplace的标识将[a->b, b->c]的路由跳转替换为[a->c]
    if (to.meta.erpReplace) {
      erpReplaceComeBackMap(from, to)
      return
    }
    // 记录路由跳转信息
    setModuleComeBackMap(from, to)
  })
}

/**
 * 根据路由信息获取需要返回的模块信息
 * @export
 * @param {*} path 路由菜单path
 * @returns { fullPath: '/ams/efficiency', useOpen: true }
 */
export function getMenuComeBackRoute (path) {
  try {
    if (!path) {
      return null
    }
    const pathRoute = router.resolve(path).route
    const tag = pathRoute.meta.tag
    const menuRouterData = getModuleRoutePath(tag, pathRoute.name)
    const menuModuleUseOpen = moduleUseOpen[tag]
    if (menuRouterData && menuRouterData.form.fullPath) {
      return {
        fullPath: menuRouterData.form.fullPath,
        useOpen: menuModuleUseOpen
      }
    } else {
      return null
    }
  } catch (error) {
    console.error('ERP_ERROR:getMenuComeBackRoute', error)
    return null
  }
}

/**
 * 自动返回的入口方法，通过当前路由去匹配路由跳转信息对象查来查找到可以自动返回到路由信息
 * 利用getMenuComeBackRoute获取返回路由，再判断以那种方式进行跳转返回
 * 两种跳转方式：模块间跳转利用lacation.hash的方式、模块内跳转利用router.replace的方式
 * @returns { true: 能自动返回 false: 不能自动返回 }
 */
function autoComeBack () {
  const path = router.currentRoute.path
  const menuComeBackRoute = getMenuComeBackRoute(path)
  if (menuComeBackRoute && menuComeBackRoute.fullPath) {
    console.info('%c框架自动返回提示说明:命中自动返回, 返回到:', 'color: #8b60f0', menuComeBackRoute.fullPath)
    const resolveRoute = router.resolve(menuComeBackRoute.fullPath).route
    if (resolveRoute.meta.tag === router.currentRoute.meta.tag) {
      router.replace(menuComeBackRoute.fullPath)
    } else {
      // 模块间跳转：已经被打开过的模块需要设置layout为true，确保返回不刷新
      setRouteLayout(resolveRoute)
      // 判断不是用户主动打开的模块返回时需要关闭
      if (!menuComeBackRoute.useOpen) {
        closeVisitedModule()
      }
      // 模拟模块切换 激活模块
      window.location.hash = '#' + getPathByTag(menuComeBackRoute.fullPath, resolveRoute.meta.tag)
    }
    return true
  }
  return false
}


// 返回按钮打标记 确保不记录返回的路由跳转信息
function setComeBackStatus () {
  router.currentRoute.meta.comeBackStatus = true
}

// 自动返回的监听入口
handComeBackByAfterRouter()

// 将方法挂载在window上是确保该js的状态不被分包引入时被覆盖的问题（分包引入导出方法导致内存对象被重新创建）
window.___ERP_AUTO_COME_BACK__ = autoComeBack
window.___ERP_SET_COME_BACK_STATUS__ = setComeBackStatus



// WEBPACK FOOTER //
// ./src/layout/layout/setup/system-comeback.js